/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Music_Notes_TitleInputs */



/**
* | output |
* | --- |
* | "Insert Music Notes" |
*
* @param {Insert_Music_Notes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_music_notes_title = /** @type {((inputs?: Insert_Music_Notes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Music_Notes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer des notes de musique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Musiknoten einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci note musicali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить ноты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar notas musicales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入音符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音符を挿入する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संगीत नोट्स डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir notas musicais")
	return /** @type {LocalizedString} */ ("Insert Music Notes")
});